export default "__VITE_ASSET__B5h79_$0__"